// Lane B6's screens in the shell's view registry (plan I-2). The shell matches a RegExp against
// `[route.view, ...route.parts].join("/")`; the most specific registration wins and gates name the tools a seat must
// see in the manifest before the route resolves.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { PanelChangeReviewRoute } from "@/views/panel/PanelChangeReview";

// S12 — Kickoff & Packets (#requisitions/<R>/packets) is not registered here: V1's PacketSet route hosts it (one
// mount, views/PacketSet.tsx), so the V1 packet-set walks keep their route and gates. It moves to a registration with
// the requisition's lane tabs (B2's registerRequisitionTab) when the shell re-hosts the requisition's V1 sections.

// S13 — the panel-change review: #requisitions/<R>/panel-changes/<pcr_…>
registerView(
  /^requisitions\/[^/]+\/panel-changes\/pcr_[^/]+$/,
  (props: ViewProps) => createElement(PanelChangeReviewRoute, props),
  { lane: "B6", gates: ["panel.open_change"] },
);
